import Icon from '@components/icon/Icon';

import theme from '../../../themes/colors';

const AttendancePaymentLinkInfo = () => (
  <div className="mt-2 flex items-center gap-1 rounded-md border border-cofeeBlue2 bg-[#FFF9F6] px-3 py-2.5 text-sm text-cofeeNeutral10">
    <Icon name="alert-circle" size="24" stroke={theme.cofeeOrange6} />
    <span className="text-cofeeNeutral10">
      Fee will be calculated for attendance marked till the previous day.
    </span>
  </div>
);

export default AttendancePaymentLinkInfo;
